import {
    IWayPointCreationSingleVoyage,
    IWayPointCreationWithCorrectionsSingleVoyage
} from "@containers/singleVoyage/types/point";
import {
    getPointDefaultPlannedArrivalMutateSingleVoyage,
    getPointDefaultPlannedDepartureMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/points/helpers/getPointDefaultDate";
import {getRandomNumber} from "@helpers/number/getRandomNumber";

export const buildDefaultPointMutateSingleVoyage = ({
                                                        name,
                                                        address,
                                                        radius,
                                                        id,
                                                        type,
                                                        plannedOrdinal,
                                                        plannedDeparture,
                                                        plannedArrival,
                                                        geom,
                                                        status,
                                                        shapeOrdinal
                                                    }: Partial<IWayPointCreationSingleVoyage>): IWayPointCreationWithCorrectionsSingleVoyage => {
    return {
        name: name ?? '...',
        address: address ?? '...',
        type: type ?? 'POINT_RADIUS',
        plannedOrdinal: plannedOrdinal || 0,
        plannedDeparture: plannedDeparture || getPointDefaultPlannedDepartureMutateSingleVoyage(),
        plannedArrival: plannedArrival || getPointDefaultPlannedArrivalMutateSingleVoyage(),
        radius: radius ?? 50,
        id: id ?? getRandomNumber(),
        geom: geom || {
            type: 'Point',
            coordinates: [0, 0]
        },
        status: status || 'PLANNED',
        shapeOrdinal: shapeOrdinal || 0,
        correctionWaypoints:[],
        waypointTemplateId:null,
    }
}
